<template>
  <div class="main-section main-section--white">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 push-xl-2">
          <page-title>Ui Elements Page</page-title>

          <switch-input
            v-model="isVerticalLayout"
            class="flowting-switch"
            direction="vertical"
            label="Enable Vertical Form Layout"
            name="vertical-layout"
          />

          <text-inputs :direction="direction" />
          <security-indicators :direction="direction" />
          <text-area-inputs :direction="direction" />
          <select-inputs :direction="direction" />
          <switch-inputs :direction="direction" />
          <button-inputs :direction="direction" />
          <radio-bar-inputs :direction="direction" />
          <tags-inputs :direction="direction" />
          <documents-inputs :direction="direction" />
          <notifications :direction="direction" />
          <dropdowns :direction="direction" />
          <nav-bars :direction="direction" />
          <modals :direction="direction" />
        </div>
      </div>
    </div>
  </div>
</template>


<template>
  <div class="text-page main-section main-section--white">
    <div class="main-section main-section--white">
      <div class="container">
        <div class="row">
          <div class="col-xl-8 push-xl-2">
            <h1>Headline 1</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt cupiditate voluptates dolor vel quo amet aliquid sunt tempora quod modi deleniti, ea hic eligendi magnam natus corrupti qui eum. Dolore!</p>

            <h2>Headline 2</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt cupiditate voluptates dolor vel quo amet aliquid sunt tempora quod modi deleniti, ea hic eligendi magnam natus corrupti qui eum. Dolore!</p>

            <h3>Headline 3</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt cupiditate voluptates dolor vel quo amet aliquid sunt tempora quod modi deleniti, ea hic eligendi magnam natus corrupti qui eum. Dolore!</p>

            <h4>Headline 4</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt cupiditate voluptates dolor vel quo amet aliquid sunt tempora quod modi deleniti, ea hic eligendi magnam natus corrupti qui eum. Dolore!</p>

            <h5>Headline 5</h5>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt cupiditate voluptates dolor vel quo amet aliquid sunt tempora quod modi deleniti, ea hic eligendi magnam natus corrupti qui eum. Dolore!</p>

            <h6>Headline 6</h6>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt cupiditate voluptates dolor vel quo amet aliquid sunt tempora quod modi deleniti, ea hic eligendi magnam natus corrupti qui eum. Dolore!</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'TextPage'
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/TextPage.vue